import { serviceRequest } from './service-request';
import type { FeaturePreviewViewModel } from '@cognitoforms/types/server-types/services/controllers/svc-controllers/feature-preview-controller+-feature-preview-view-model';

export function getPreviewFeatures(): Promise<FeaturePreviewViewModel> {
	return serviceRequest('svc/feature-preview', null, {
		method: 'GET'
	});
}

export function optIn(feature: string, optIn: boolean) {
	return serviceRequest('svc/feature-preview/opt-in', {
		feature,
		optIn
	});
}